// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"596ab4f7","921":"2e268782"}[chunkId] + ".chunk.js";
};